<template>
  <div>
    <card title="Réplica de Denúncias">
      <template slot="content">
        <div v-if="!isErroGetDados">
          <div class="row">
            <div class="col-md-6">
              <h4>Denúncia: {{ denuncia.protocolo }}</h4>
            </div>
            <div class="col-md-6 alinhamento-direita">
              <h4 v-if="denuncia.tipo_id"> Classificação: {{this.denuncia.tipo.tipo}}</h4>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 espacamento">
              <b-progress height="20px" :max="100">
                <b-progress-bar
                  v-bind:style="[cBackgroundColor, {fontSize: '16px',fontWeight: '700'}]"
                  :value="cValue"
                  :label="cLabel">
                </b-progress-bar>
              </b-progress>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h5>Informações</h5>
              <hr>
            </div>
          </div>

          <div class="row align-items-center justify-content-center">
            <div class="col-md-12 text-justify text-break">
              <h6>Data de Abertura: <span class="texto-informacoes">{{ retornarData(denuncia.created_at) }}</span></h6>
              <h6>Criado por: <span class="texto-informacoes">{{ cCriadoPor }}</span></h6>
              <h6>Data de Nascimento: <span class="texto-informacoes">{{ cDataNascimento }}</span></h6>
              <h6>Telefone: <span class="texto-informacoes">{{ cPhone }}</span></h6>
              <h6>Email: <span class="texto-informacoes">{{ cEmail }}</span></h6>
              <h6>Relação: <span class="texto-informacoes">{{ cRelacao }}</span></h6>
              <h6>Descrição: <span class="texto-informacoes">{{ denuncia.descricao }}</span></h6>
              <template v-if="cAnexo">
                <h6>Anexos:</h6>
                <h6 v-for="item in denuncia.arquivos" :key="item.local">
                  <a @click="downloadArquivo(item)">{{ item.nome }}</a>
                </h6>
              </template>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 alinhamento-direita">
              <button class="btn btn-primary" @click="abrirModalDeClassificar">
                Classificar Denúncia
              </button>
              <button class="btn btn-success"  @click="abrirModalDeReplica" :disabled="encerrado">
                Responder Denúncia
              </button>
            </div>
          </div>
        </div>
        <div v-else class="container alinhar-centro container-campo-central">
          <h4>Ocorreu um erro, tente novamente!</h4>
        </div>
      </template>
    </card>

    <div class="container content-box">
      <div class="row">
        <div class="col-md-6">
          <h5>Respostas</h5>
        </div>
        <div v-if="replicas != ''" class="col-md-6 alinhamento-direita">
          <button class="btn btn-primary botao-inverter-ordem" @click="reverse">
            <i class="fa fa-exchange icone-vertical"></i>
          </button>
        </div>
      </div>
      <div v-if="replicas != ''">
        <div class="row" v-for="item in replicas" v-bind:key="item.id">
          <div class="col-md-12 espacamento">
            <hr>
            <div class="row espacamento">
              <div class="col-md-4">
                <h6>{{ item.usuario.email }}</h6>
              </div>
              <div class="col-md-4 resposta-data-alinhamento">
                <h6 class="cor-data-card"> {{ retornarData(item.created_at) }}</h6>
              </div>
              <div class="col-md-4 resposta-status-alinhamento">
                <h6>{{ item.status.status }}</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 text-justify">
                <p>{{ item.descricao }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="col-md-12">
            <p>A denúncia não contém nenhuma resposta.</p>
          </div>
        </div>
      </div>
    </div>

    <meta-modal
      id="modalSucesso"
      size="lg"
      :hideFooter="true"
      :hideHeader="true"
      ref="replica"
      title="Faça uma réplica para a denúncia"
      width="600px"
      :only-modal="true">
      <template slot="body">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <h3>Replica da denúncia: {{ denuncia.protocolo }}</h3>
                <hr>
                <meta-select
                  id="relacao"
                  label="Selecione o status da denúncia"
                  class="label"
                  name="relacao" v-model="replica.statusDenuncia"
                  attr-id="id" attr-label="status" :options="status"
                  placeholder="Selecione..."
                  required
                >
                </meta-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label
                  class="label required-label"
                  for="descricao">Descrição
                </label>
                <textarea
                  name="replicaBox"
                  id="replicaBox"
                  class="form-control textarearesize"
                  v-model="replica.descricao"
                  v-validate="{ required: true }"
                >
                </textarea>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-success pull-right" @click="enviarReplicaParaDb" :disabled="!cValidador">
                  Responder
                </button>
                <button class="btn btn-sencondary pull-right" style="margin-right:5px;" @click="fecharModalDeReplica">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </meta-modal>

    <meta-modal
      id="modalSucesso"
      size="lg"
      :hideFooter="true"
      :hideHeader="true"
      ref="classifica"
      title="Classifique a denúncia"
      width="600px"
      :only-modal="true">
      <template slot="body">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <h3>Classifique a denúncia: {{ denuncia.protocolo }}</h3>
                <hr>
                <meta-select
                  id="tipo"
                  label="Selecione o tipo da denúncia"
                  class="label"
                  name="tipo" v-model="selectedTipo"
                  attr-id="id" attr-label="tipo" :options="tipos"
                  placeholder="Selecione..."
                  required
                >
                </meta-select>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-success pull-right" @click="enviarClassificacaoParaDb" :disabled="!cValidadorModalClassificacao">
                  Salvar
                </button>
                <button class="btn btn-sencondary pull-right" style="margin-right:5px;" @click="fecharModalDeClassificar">
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </meta-modal>
  </div>
</template>


<style scoped>
  #btn-fechar {
    background-color: #97CA40 !important;
    border-color: #97CA40;
    color: white;
  }

  div {
    font-family: 'Lato', sans-serif;
  }

  p {
    font-weight: 300;
  }

  h3, h4, h5, h6 {
    color: #142260;
    font-weight: 700;
  }

  hr {
    margin: 0px;
    padding-bottom: 5px;
  }

  .texto-informacoes {
    color: #494949;
    font-weight: 300;
  }

  .cor-data-card {
    color: rgb(43, 43, 43);
    font-weight: 300;
  }

  .espacamento {
    padding-top: 0.2vh;
  }

  .responsive-margin {
    margin-top: 2vh;
  }

  .botao-inverter-ordem {
    zoom: 1.2;
    margin-bottom: 5px;
  }

  .icone-vertical {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .alinhamento-direita {
    text-align: right;
  }

  .alinhamento-centro {
    text-align: center;
  }

  .design-modal-erro {
    color: #232323;
    font-weight:400;
  }

  .textarearesize{
    resize: vertical;
  }

  .resposta-status-alinhamento {
    text-align: right;
  }

  .resposta-data-alinhamento {
    text-align: center;
  }

  @media (max-width: 425px)  {
    .resposta-data-alinhamento {
      text-align: left;
    }
    .resposta-status-alinhamento {
      text-align: left;
    }
  }
</style>

<script>
import MetaText from 'meta-text'
import MetaSelect from 'meta-select'
import MetaModal from 'meta-modal'
import Card from './templates/Card.vue'
import Utils from '@/mixins/utils.js'

export default {
  name: 'replicaDenuncia',

  inject: ['$validator'],

  components: {
    MetaText,
    MetaSelect,
    MetaModal,
    Card,
  },

  mixins: [
    Utils,
  ],

  data () {
    return {
      isErroGetDados: false,
      status: [],
      tipos: [],
      denuncia: {},
      denunciaToken: this.$route.params.token,
      replica: {
        usuarioId: '',
        statusDenuncia: null,
        descricao: '',
      },
      selectedTipo: null,
      replicas: [],
    };
  },

  updated() {
    if (this.$refs.modalErro) {
      this.$refs.modalErro.abrir();
    }
  },

  computed: {
    cValue() {
      if (this.denuncia.historicos && this.denuncia.historicos.length > 0) {
        const divisaoBarra = 100/this.status.length;
        const barraProgresso = divisaoBarra*this.denuncia.historicos[this.key].status_id;
        return barraProgresso;
      }
      return 100/this.status.length;
    },

    cBackgroundColor() {
      let background = '#97CA40';
      if (this.denuncia.historicos &&
      this.denuncia.historicos.length > 0 &&
      this.denuncia.historicos[this.key].status_id == this.status.length) {
        background = '#2855A6';
      }
      return {backgroundColor: background};
    },

    cLabel() {
      if (this.denuncia.historicos &&
      this.denuncia.historicos.length > 0) {
        return this.denuncia.historicos[this.key].status.status;
      }
      return 'Aberto';
    },

    cRelacao() {
      if (this.denuncia.relacao_id == null) {
        return 'Não informado';
      }
      return this.denuncia.relacao.relacao;
    },

    cCriadoPor() {
      if (this.denuncia.criado_por == null) {
        return 'Anônimo';
      }
      return this.denuncia.criado_por;
    },

    cDataNascimento() {
      return !this.denuncia.data_nascimento ? 'Não informado' : this.denuncia.data_nascimento;
    },

    cPhone() {
      if(!this.denuncia.phone) {
        return 'Não Informado';
      }

      return this.denuncia.phone;
    },

    cEmail() {
      if(!this.denuncia.email) {
        return 'Não Informado';
      }

      return this.denuncia.email;
    },

    cValidador() {
      return this.replica.descricao.length && this.replica.statusDenuncia;
    },

    cValidadorModalClassificacao() {
      return this.selectedTipo;
    },

    key() {
      if (this.denuncia.historicos) {
        return this.denuncia.historicos.length - 1;
      }

      return 0;
    },

    encerrado() {
      if (this.key > 0) {
        return this.denuncia.historicos[this.key].status_id == 3;
      }

      return false;
    },

    cAnexo() {
      if (!this.denuncia.arquivos) {
        return false;
      }

      if (this.denuncia.arquivos.length == 0) {
        return false;
      }

      return true;
    },
  },

  mounted() {
    this.ordenarStatus();
    this.buscarTipos();
    this.atualizarReplicas();
  },

  methods: {
    retornarData(data) {
      const moment = this.$moment(data);
      const formatoData =  moment.format('DD/MM/YYYY - HH:mm');

      return formatoData;
    },

    abrirModalDeReplica () {
      this.$refs.replica.abrir();
    },

    abrirModalDeClassificar(){
      this.$refs.classifica.abrir();
    },

    fecharModalDeReplica () {
      this.$refs.replica.fechar();
      this.replica.descricao = '';
    },

    fecharModalDeClassificar () {
      this.$refs.classifica.fechar();
    },

    async enviarReplicaParaDb () {
      try {
        this.$parent.loading = true;

        const { data: denuncias } = await this.$http.get(`/denuncias/${this.denunciaToken}`);
        this.denuncias = denuncias;

        await this.$http.post('/historico', {
          denuncia_id: this.idDdenuncia,
          status_id: this.replica.statusDenuncia.id,
          descricao: this.replica.descricao,
          usuario_id: 3,
        });

        this.replica.descricao = '';
        this.atualizarReplicas();

        this.customAlert(
          'Sucesso!',
          'Sua réplica foi enviada.',
          'success',
        );
      } catch(e) {
        this.customAlert(
          'Ocorreu um erro!',
          'Entre em contato com o administrador do sistema.',
          'error',
        );
      } finally {
        this.$parent.loading = false;
        this.$refs.replica.fechar();
      }
    },

    async enviarClassificacaoParaDb () {
      try {
        this.$parent.loading = true;

        const { data: denuncias } = await this.$http.get(`/denuncias/${this.denunciaToken}`);
        this.denuncias = denuncias;

        await this.$http.post('/denuncia/tipo', { id: this.idDdenuncia, tipo_id: this.selectedTipo.id });

        this.denuncia.tipo =  this.selectedTipo;
        this.denuncia.tipo_id = this.selectedTipo.id;

        this.customAlert(
          'Sucesso!',
          'Classificação salva.',
          'success',
        );
      } catch(e) {
        this.customAlert(
          'Ocorreu um erro!',
          'Entre em contato com o administrador do sistema.',
          'error',
        );
      } finally {
        this.$parent.loading = false;
        this.$refs.classifica.fechar();
      }
    },

    async atualizarReplicas() {
      try {
        this.$parent.loading = true;

        const { data: response } = await this.$http.get(`/denuncias/`+this.denunciaToken);
        this.denuncia = response;
        this.idDdenuncia = response.id;
        this.denuncia.historicos = this.denuncia.historicos;
        this.replicas = Array.of(...this.denuncia.historicos);
      } catch (e) {
        this.isErroGetDados = true;
      } finally {
        this.$parent.loading = false;
      }
    },

    reverse() {
      this.replicas.reverse()[0].status.status;
    },

    async ordenarStatus() {
      try {
        this.$parent.loading = true;

        const { data: response } = await this.$http.get('/status');
        this.status = response;
        this.status = this.status.reverse();

      } catch (e) {
        this.isErroGetDados = true;
      } finally {
        this.$parent.loading = false;
      }
    },

    async buscarTipos() {
      try {
        this.$parent.loading = true;

        const { data: response } = await this.$http.get('/denuncia/tipos');
        this.tipos = response;

      } catch (e) {
        this.isErroGetDados = true;
      } finally {
        this.$parent.loading = false;
      }
    },

    async downloadArquivo(arquivo) {
      try {
        this.$parent.loading = true;
        const { data: response } =  await this.$http.get(`/verifica-arquivo/${arquivo.id}`);
        if(!response.success) {
          this.$parent.loading = false;
          this.customAlert(
            'Erro!',
            'Erro ao efetuar o download do arquivo.',
            'error',
          );
          return;
        }

        window.open(`${this.$root.url}/arquivo-download/${arquivo.id}?Key=${this.$root.chaveFront}`);
      } catch (e) {
        this.isErroGetDados = true;
      } finally {
        this.$parent.loading = false;
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ReplicaDenuncia.vue